import React from "react";
import LdReport from "./components/Report/ldReport";

const Toaster = React.lazy(() =>
  import("./views/notifications/toaster/Toaster")
);
const Tables = React.lazy(() => import("./views/base/tables/Tables"));

const Breadcrumbs = React.lazy(() =>
  import("./views/base/breadcrumbs/Breadcrumbs")
);
const Cards = React.lazy(() => import("./views/base/cards/Cards"));
const Carousels = React.lazy(() => import("./views/base/carousels/Carousels"));
const Collapses = React.lazy(() => import("./views/base/collapses/Collapses"));
const BasicForms = React.lazy(() => import("./views/base/forms/BasicForms"));

const Jumbotrons = React.lazy(() =>
  import("./views/base/jumbotrons/Jumbotrons")
);
const ListGroups = React.lazy(() =>
  import("./views/base/list-groups/ListGroups")
);
const Navbars = React.lazy(() => import("./views/base/navbars/Navbars"));
const Navs = React.lazy(() => import("./views/base/navs/Navs"));
const Paginations = React.lazy(() =>
  import("./views/base/paginations/Pagnations")
);
const Popovers = React.lazy(() => import("./views/base/popovers/Popovers"));
const ProgressBar = React.lazy(() =>
  import("./views/base/progress-bar/ProgressBar")
);
const Switches = React.lazy(() => import("./views/base/switches/Switches"));

const Tabs = React.lazy(() => import("./views/base/tabs/Tabs"));
const Tooltips = React.lazy(() => import("./views/base/tooltips/Tooltips"));
const BrandButtons = React.lazy(() =>
  import("./views/buttons/brand-buttons/BrandButtons")
);
const ButtonDropdowns = React.lazy(() =>
  import("./views/buttons/button-dropdowns/ButtonDropdowns")
);
const ButtonGroups = React.lazy(() =>
  import("./views/buttons/button-groups/ButtonGroups")
);
const Buttons = React.lazy(() => import("./views/buttons/buttons/Buttons"));
const Charts = React.lazy(() => import("./views/charts/Charts"));
const Dashboard = React.lazy(() => import("./views/dashboard/Dashboard"));
const CoreUIIcons = React.lazy(() =>
  import("./views/icons/coreui-icons/CoreUIIcons")
);
const Flags = React.lazy(() => import("./views/icons/flags/Flags"));
const Brands = React.lazy(() => import("./views/icons/brands/Brands"));
const Alerts = React.lazy(() => import("./views/notifications/alerts/Alerts"));
const Badges = React.lazy(() => import("./views/notifications/badges/Badges"));
const Modals = React.lazy(() => import("./views/notifications/modals/Modals"));
const Colors = React.lazy(() => import("./views/theme/colors/Colors"));
const Typography = React.lazy(() =>
  import("./views/theme/typography/Typography")
);
const Widgets = React.lazy(() => import("./views/widgets/Widgets"));
//const Users = React.lazy(() => import('./views/users/Users'));
const UserList = React.lazy(() => import("./components/Users/UserList"));
const ConfigForm = React.lazy(() =>
  import("./components/ConfigModule/ConfigForm")
);
const AddUser = React.lazy(() => import("./components/Users/AddUser"));
const User = React.lazy(() => import("./views/users/User"));
const LeadList = React.lazy(() => import("./components/Lead/LeadList"));
const CustomerList = React.lazy(() => import("./components/Lead/CustomerList"));
const CustomerLeadEdit = React.lazy(() => import("./containers/CustomerLead"));

const LeadDetail = React.lazy(() => import("./components/Lead/LeadDetails"));
const LDReport = React.lazy(() => import("./components/Report/ldReport"));
const LeadReport = React.lazy(() => import("./components/Report/leadreport"));
const MainLeadStatusList = React.lazy(() =>
  import("./components/MainLeadStatus/StatusList")
);
const AddMainLeadStatus = React.lazy(() =>
  import("./components/MainLeadStatus/AddStatus")
);
const MainLeadSubStatusList = React.lazy(() =>
  import("./components/MainLeadSubStatus/SubStatusList")
);
const AddMainLeadSubStatus = React.lazy(() =>
  import("./components/MainLeadSubStatus/AddSubStatus")
);
const SourceList = React.lazy(() => import("./components/Source/SourceList"));
const AddSource = React.lazy(() => import("./components/Source/AddSource"));
const SubLeadStatusList = React.lazy(() =>
  import("./components/SubLeadStatus/StatusList")
);
const AddSubLeadStatus = React.lazy(() =>
  import("./components/SubLeadStatus/AddStatus")
);
const SubSourceList = React.lazy(() =>
  import("./components/SubSource/SubSourceList")
);
const AddSubSource = React.lazy(() =>
  import("./components/SubSource/AddSubSource")
);
const SubLeadSubStatusList = React.lazy(() =>
  import("./components/SubLeadSubStatus/SubStatusList")
);
const AddSubLeadSubStatus = React.lazy(() =>
  import("./components/SubLeadSubStatus/AddSubStatus")
);
const UploadLeadList = React.lazy(() =>
  import("./components/Lead/UploadLeadList")
);
const UploadLead = React.lazy(() => import("./components/Lead/UploadLead"));
const UploadUpdateLeadList = React.lazy(() =>
  import("./components/Lead/UploadUpdateLeadList")
);
const UploadUpdateLead = React.lazy(() =>
  import("./components/Lead/UploadUpdateLead")
);
const PermissionList = React.lazy(() =>
  import("./components/Permission/PermissionList")
);
const AddPermission = React.lazy(() =>
  import("./components/Permission/AddPermission")
);
const PermissonCategory = React.lazy(() =>
  import("./components/PermissionCategory/CategoryList")
);
const AddPermissonCategory = React.lazy(() =>
  import("./components/PermissionCategory/AddCategory")
);
const RoleList = React.lazy(() => import("./components/Role/RoleList"));
const AddRole = React.lazy(() => import("./components/Role/AddRole"));
const DialerList = React.lazy(() => import("./components/Dialer/DialerList"));
const AddDialer = React.lazy(() => import("./components/Dialer/AddDialer"));
const PackList = React.lazy(() => import("./components/Pack/PackList"));
const AddPack = React.lazy(() => import("./components/Pack/AddPack"));
const PackUploader = React.lazy(() => import("./components/Pack/PackUploader"));
const VendorList = React.lazy(() => import("./components/Vendor/VendorList"));
const AddVendor = React.lazy(() => import("./components/Vendor/AddVendor"));
const LDLeadList = React.lazy(() => import("./components/LDLead/LDLeadList"));
const LDLeadDetail = React.lazy(() =>
  import("./components/LDLead/LDLeadDetail")
);
const LeadRatio = React.lazy(() => import("./components/Lead/LeadRatio"));
const AddLdLeadRatio = React.lazy(() =>
  import("./components/Lead/AddLdLeadRatio")
);
const SubLeadList = React.lazy(() => import("./components/Lead/SubLeadList"));
const MissedSubLeadList = React.lazy(() =>
  import("./components/Lead/MissedSubLeadList")
);
const SubLeadDetails = React.lazy(() =>
  import("./components/Lead/SubLeadDetails")
);
const ReportModule = React.lazy(() =>
  import("./components/Report/ReportModule")
);
const SubLeadUploader = React.lazy(() =>
  import("./containers/SubLoadUploader")
);

const DialerStatus = React.lazy(() =>
  import("./components/Dialer/DialerStatus")
);
const DialerSubStatus = React.lazy(() =>
  import("./components/Dialer/DialerSubStatus")
);

const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  { path: "/user", name: "Theme", component: Colors, exact: true },
  { path: "/lead", name: "Raw Lead Listing", component: LeadList, exact: true },

  {
    path: "/customer",
    name: "Customer List",
    component: CustomerList,
    exact: true,
  },

  {
    path: "/subleads",
    name: "Sub Lead Listing",
    component: SubLeadList,
    exact: true,
  },
  {
    path: "/subleads/:customer_id",
    name: "Edit Customer's Lead",
    component: CustomerLeadEdit,
    exact: true,
  },

  {
    path: "/missed-subleads",
    name: "Missed Sub Lead Listing",
    component: MissedSubLeadList,
    exact: true,
  },
  { path: "/ldreport", name: "LD Report", component: LDReport, exact: true },
  {
    path: "/leadreport",
    name: "Lead Report",
    component: LeadReport,
    exact: true,
  },
  { path: "/theme/colors", name: "Colors", component: Colors },
  { path: "/theme/typography", name: "Typography", component: Typography },
  { path: "/base", name: "Base", component: Cards, exact: true },
  { path: "/base/breadcrumbs", name: "Breadcrumbs", component: Breadcrumbs },
  { path: "/base/cards", name: "Cards", component: Cards },
  { path: "/base/carousels", name: "Carousel", component: Carousels },
  { path: "/base/collapses", name: "Collapse", component: Collapses },
  { path: "/base/forms", name: "Forms", component: BasicForms },
  { path: "/base/jumbotrons", name: "Jumbotrons", component: Jumbotrons },
  { path: "/base/list-groups", name: "List Groups", component: ListGroups },
  { path: "/base/navbars", name: "Navbars", component: Navbars },
  { path: "/base/navs", name: "Navs", component: Navs },
  { path: "/base/paginations", name: "Paginations", component: Paginations },
  { path: "/base/popovers", name: "Popovers", component: Popovers },
  { path: "/base/progress-bar", name: "Progress Bar", component: ProgressBar },
  { path: "/base/switches", name: "Switches", component: Switches },
  { path: "/base/tables", name: "Tables", component: Tables },
  { path: "/base/tabs", name: "Tabs", component: Tabs },
  { path: "/base/tooltips", name: "Tooltips", component: Tooltips },
  { path: "/buttons", name: "Buttons", component: Buttons, exact: true },
  { path: "/buttons/buttons", name: "Buttons", component: Buttons },
  {
    path: "/buttons/button-dropdowns",
    name: "Dropdowns",
    component: ButtonDropdowns,
  },
  {
    path: "/buttons/button-groups",
    name: "Button Groups",
    component: ButtonGroups,
  },
  {
    path: "/buttons/brand-buttons",
    name: "Brand Buttons",
    component: BrandButtons,
  },
  { path: "/charts", name: "Charts", component: Charts },
  { path: "/icons", exact: true, name: "Icons", component: CoreUIIcons },
  { path: "/icons/coreui-icons", name: "CoreUI Icons", component: CoreUIIcons },
  { path: "/icons/flags", name: "Flags", component: Flags },
  { path: "/icons/brands", name: "Brands", component: Brands },
  {
    path: "/notifications",
    name: "Notifications",
    component: Alerts,
    exact: true,
  },
  { path: "/notifications/alerts", name: "Alerts", component: Alerts },
  { path: "/notifications/badges", name: "Badges", component: Badges },
  { path: "/notifications/modals", name: "Modals", component: Modals },
  { path: "/notifications/toaster", name: "Toaster", component: Toaster },
  { path: "/widgets", name: "Widgets", component: Widgets },
  { path: "/users", exact: true, name: "Users", component: UserList },
  { path: "/config", exact: true, name: "Config", component: ConfigForm },
  {
    path: "/users/add",
    exact: true,
    name: " Add Users Details",
    component: AddUser,
  },
  {
    path: "/users/:id",
    exact: true,
    name: " Edit User Details",
    component: AddUser,
  },
  {
    path: "/lead/:lead_id",
    exact: true,
    name: "Lead Details",
    component: LeadDetail,
  },
  {
    path: "/subleads/:lead_id?/:sub_lead_id?",
    exact: true,
    name: "Sub Lead Details",
    component: SubLeadDetails,
  },
  {
    path: "/uploadlead",
    exact: true,
    name: "Upload Lead Details",
    component: UploadLeadList,
  },
  {
    path: "/uploadlead/add",
    exact: true,
    name: "Add Upload Lead Details",
    component: UploadLead,
  },
  {
    path: "/uploadupdatelead",
    exact: true,
    name: "Upload Lead Details",
    component: UploadUpdateLeadList,
  },
  {
    path: "/uploadupdatelead/add",
    exact: true,
    name: "Add Upload Lead Details",
    component: UploadUpdateLead,
  },
  {
    path: "/mainleadstatus",
    exact: true,
    name: "Main Lead Status",
    component: MainLeadStatusList,
  },
  {
    path: "/mainleadstatus/add",
    exact: true,
    name: " Add Main Lead Status",
    component: AddMainLeadStatus,
  },
  {
    path: "/mainleadstatus/:status_id",
    exact: true,
    name: " Edit Main Lead Status",
    component: AddMainLeadStatus,
  },
  {
    path: "/mainleadsubstatus",
    exact: true,
    name: "Main Lead Sub Status",
    component: MainLeadSubStatusList,
  },
  {
    path: "/mainleadsubstatus/add",
    exact: true,
    name: " Add Main Lead Sub Status",
    component: AddMainLeadSubStatus,
  },
  {
    path: "/mainleadsubstatus/:sub_status_id",
    exact: true,
    name: " Edit Main Lead Sub Status",
    component: AddMainLeadSubStatus,
  },
  { path: "/source", exact: true, name: "Source", component: SourceList },
  {
    path: "/source/add",
    exact: true,
    name: "Add Source",
    component: AddSource,
  },
  {
    path: "/source/:source_id",
    exact: true,
    name: " Edit Source",
    component: AddSource,
  },
  {
    path: "/subsource",
    exact: true,
    name: "SubSource",
    component: SubSourceList,
  },
  {
    path: "/subsource/add",
    exact: true,
    name: "Add SubSource",
    component: AddSubSource,
  },
  {
    path: "/subsource/:subsource_id",
    exact: true,
    name: " Edit SubSource",
    component: AddSubSource,
  },
  {
    path: "/subleadstatus",
    exact: true,
    name: "Sub Lead Status",
    component: SubLeadStatusList,
  },
  {
    path: "/subleadstatus/add",
    exact: true,
    name: "Add Sub Lead Status",
    component: AddSubLeadStatus,
  },
  {
    path: "/subleadstatus/:status_id",
    exact: true,
    name: "Edit Sub Lead Status",
    component: AddSubLeadStatus,
  },
  {
    path: "/subleadsubstatus",
    exact: true,
    name: "Sub Lead Sub Status",
    component: SubLeadSubStatusList,
  },
  {
    path: "/subleadsubstatus/add",
    exact: true,
    name: " Add Sub Lead Sub Status",
    component: AddSubLeadSubStatus,
  },
  {
    path: "/subleadsubstatus/:substatus_id",
    exact: true,
    name: " Edit Sub Lead Sub Status",
    component: AddSubLeadSubStatus,
  },
  {
    path: "/subLeads-upload",
    exact: true,
    name: " SUb Lead Uploader",
    component: SubLeadUploader,
  },
  {
    path: "/uploadlead/add",
    exact: true,
    name: "Add Upload Lead Details",
    component: UploadLead,
  },

  {
    path: "/permission",
    exact: true,
    name: "Permisson",
    component: PermissionList,
  },
  {
    path: "/permission/add",
    exact: true,
    name: " Add Permission ",
    component: AddPermission,
  },
  {
    path: "/permission/:permission_id",
    exact: true,
    name: "Edit Permisson ",
    component: AddPermission,
  },

  {
    path: "/permission-category",
    exact: true,
    name: "Permission Category",
    component: PermissonCategory,
  },
  {
    path: "/permission-category/add",
    exact: true,
    name: "Add Permisson Category ",
    component: AddPermissonCategory,
  },
  {
    path: "/permission-category/:category_id",
    exact: true,
    name: "Edit Permission Category",
    component: AddPermissonCategory,
  },

  {
    path: "/lead-ratio",
    name: "LD Lead Ratio",
    component: LeadRatio,
    exact: true,
  },
  {
    path: "/lead-ratio/add",
    exact: true,
    name: "Add LD Lead Ratio",
    component: AddLdLeadRatio,
  },
  {
    path: "/lead-ratio/:id",
    exact: true,
    name: "Edit LD Lead Ratio",
    component: AddLdLeadRatio,
  },

  { path: "/role", exact: true, name: "Role", component: RoleList },
  { path: "/role/add", exact: true, name: "Add Role", component: AddRole },
  {
    path: "/role/:role_id",
    exact: true,
    name: "Edit Role",
    component: AddRole,
  },

  { path: "/dialer", exact: true, name: "Dialer", component: DialerList },
  {
    path: "/dialer/add",
    exact: true,
    name: " Add Dialer ",
    component: AddDialer,
  },
  {
    path: "/dialer/:dialer_id",
    exact: true,
    name: " Edit Dialer ",
    component: AddDialer,
  },

  { path: "/packs", exact: true, name: "Pack", component: PackList },
  { path: "/packs/add", exact: true, name: " Add Pack ", component: AddPack },
  {
    path: "/uploadpack",
    exact: true,
    name: "PackUploader",
    component: PackUploader,
  },
  {
    path: "/packs/:pack_id",
    exact: true,
    name: "Edit Pack ",
    component: AddPack,
  },

  { path: "/vendors", exact: true, name: "Vendor", component: VendorList },
  {
    path: "/vendors/add",
    exact: true,
    name: "Add Vendor",
    component: AddVendor,
  },
  {
    path: "/vendors/:vendor_id",
    exact: true,
    name: " Edit Vendor ",
    component: AddVendor,
  },

  { path: "/ldlead", exact: true, name: "LD Lead", component: LDLeadList },
  {
    path: "/ldlead/:lead_id",
    exact: true,
    name: "LD Lead Details",
    component: LDLeadDetail,
  },
  {
    path: "/reportsmodule",
    exact: true,
    name: "Report Module",
    component: ReportModule,
  },

  {
    path: "/dialerstatus",
    exact: true,
    name: "Dialer Status",
    component: DialerStatus,
  },
  {
    path: "/dialersubstatus",
    exact: true,
    name: "Dialer Sub Status",
    component: DialerSubStatus,
  },
];

export default routes;
